import { Text } from "@aws-amplify/ui-react";

const Footer = () => {
  return <Text>After submitting, you will be redirected back to the sign in page.</Text>;
}

export default Footer;